<template>
    <a @click.prevent="openSearch" :href="searchUrl" target="_blank" rel="nofollow">
        <slot />
    </a>
</template>

<script>
import StoreMixin from '../../mixins/store';
import EbayMixin from '../../mixins/ebay';

export default {
    mixins: [
        StoreMixin,
        EbayMixin
    ],

    props: [
        'store',
        'searchQuery'
    ],

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
